import core from '@js/core';
import form from '@ui/form';
import registerSwitch from '@ui/register-switch';
import checkbox from '@ui/checkbox';
import radioButton from '@ui/radio-button';

const ui = [form, registerSwitch, checkbox, radioButton];

core.register(ui);



// WEBPACK FOOTER //
// ./src/RMPL/CoreBundle/Resources/public/js/views/register.js